import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import API from '../../services/API';
import Table from './components/Table';
import {Button} from "react-bootstrap";

class UsersCount2 extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            report: [],
            sortParam: null,
            sortOrder: 1,
        };

        this.handleSort = this.handleSort.bind(this);
        this.handleLoadLive = this.handleLoadLive.bind(this);
        this.handleLoadRotator = this.handleLoadRotator.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;
        
        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handleLoadLive() {
        this.setState({ isLoading: true });

        API.Users.count2()
            .then(report => this.setState({ report, isLoading: false }))
    }

    handleLoadRotator() {
        this.setState({ isLoading: true });

        API.Users.countLive()
            .then(report => this.setState({ report, isLoading: false }))
    }

    getTable() {
        const { report } = this.state;

        if(!report.length) return <p>No data</p>;

        return <Table report={report} onSortChange={this.handleSort}/>
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Users Count2"/>

                <Button type="submit" bsStyle="success" className="m-b-15" onClick={this.handleLoadLive}>Load Live</Button>
                <Button type="submit" bsStyle="success" className="m-b-15" onClick={this.handleLoadRotator}>Load Rotator</Button>

                {this.getTable()}
            </Container>
        );
    }
}

export default UsersCount2;


// WEBPACK FOOTER //
// ./src/scenes/UsersCount2/index.js